<div class="wcmap-modal">
  <h4 class="wcmap-title">Welcome to {{ map_name }}</h4>
  <p class="wcmap-body">
    Place the game token where this party will begin their adventure, then click Accept (lower right) when ready to proceed.
  </p>
</div>
